import React from "react";
import { useFormik } from "formik";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import { FormGroup, Label, Modal, ModalBody, ModalHeader } from "reactstrap";
import ScheduleService from "../../../services/KangarooServices/ScheduleService";
import toast from "react-hot-toast";
import Select from "react-select";

const DAYS = [
  { value: 0, label: "Sunday" },
  { value: 1, label: "Monday" },
  { value: 2, label: "Tuesday" },
  { value: 3, label: "Wednesday" },
  { value: 4, label: "Thursday" },
  { value: 5, label: "Friday" },
  { value: 6, label: "Saturday" },
];

const WorkingScheduleForm = ({ isOpen, toggle, selectedItem, fetchdata }) => {
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      isActive: selectedItem?.isActive ?? true,
    },
    onSubmit: async (values) => {
      try {
        const payload = { ...values }; // only isActive
        const response = await ScheduleService.updateWorkingList(
          selectedItem?.id,
          payload
        );
        toast.success(response);
        fetchdata();
        toggle();
      } catch (error) {
        console.log(error);
        toast.error(error);
      }
    },
  });

  if (!isOpen) return null;

  const statusOptions = [
    { label: "Active", value: true },
    { label: "Inactive", value: false },
  ];

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Working Schedule Form</ModalHeader>
      <ModalBody>
        <form onSubmit={formik.handleSubmit}>
          {/* Day of Week (readonly) */}
          <div className="mb-3">
            <label className="form-label">Day</label>
            <input
              type="text"
              className="form-control"
              value={
                DAYS.find((day) => day.value === selectedItem?.dayOfWeek)
                  ?.label || ""
              }
              readOnly
            />
          </div>

          {/* Status */}
          <FormGroup className="mb-3">
            <Label>Status</Label>
            <Select
              options={statusOptions}
              value={statusOptions.find(
                (opt) => opt.value === formik.values.isActive
              )}
              onChange={(selected) =>
                formik.setFieldValue("isActive", selected.value)
              }
            />
          </FormGroup>

          {/* Footer */}
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={toggle}
            >
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              Update
            </button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default WorkingScheduleForm;
